/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrNumericColumnModule } from './igr-numeric-column-module';
import { IgrDateTimeColumnModule } from './igr-date-time-column-module';
import { IgrImageColumnModule } from './igr-image-column-module';
import { IgrTemplateColumnModule } from './igr-template-column-module';
import { IgrTextColumnModule } from './igr-text-column-module';
import { IgrTemplateHeaderModule } from './igr-template-header-module';
import { IgrComboBoxColumnModule } from './igr-combo-box-column-module';
import { IgrDataGridCoreModule } from './igr-data-grid-core-module';
var IgrDataGridAllColumnsModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrDataGridAllColumnsModule() {
    }
    IgrDataGridAllColumnsModule.register = function () {
        IgrNumericColumnModule.register();
        IgrDateTimeColumnModule.register();
        IgrImageColumnModule.register();
        IgrTemplateColumnModule.register();
        IgrTextColumnModule.register();
        IgrTemplateHeaderModule.register();
        IgrComboBoxColumnModule.register();
        IgrDataGridCoreModule.register();
    };
    return IgrDataGridAllColumnsModule;
}());
export { IgrDataGridAllColumnsModule };
//# sourceMappingURL=igr-data-grid-all-columns-module.js.map
